import { commonSemanticActionLabels } from "./common-actions";

export const platformAdminValues = {
  semanticActions: {
    authorize: "認可",
    viewBindings: "権限バインディング",
    viewCatalog: "ロールカタログ",
    viewSnapshot: "メンバー概要",
    manageCredentials: "認証情報",
    openDirectorWorkspace: "ディレクター作業台を開く",
    openJudgeWorkspace: "判定作業台を開く",
    openReviewWorkspace: "レビュー作業台を開く",
    generate: commonSemanticActionLabels.generate,
    configure: commonSemanticActionLabels.configure,
    commit: commonSemanticActionLabels.commit,
    rejudge: "再判定",
    instantiate: "インスタンス化",
    compare: commonSemanticActionLabels.compare,
    resetPassword: commonSemanticActionLabels.resetPassword,
    unlock: commonSemanticActionLabels.unlock,
    lock: commonSemanticActionLabels.lock,
    impersonate: "ユーザー代入",
    kickout: "強制ログアウト",
    customFields: "カスタム項目",
    openConsole: "コンソールを開く",
    openVnc: "VNC を開く",
    extend: commonSemanticActionLabels.extend,
    destroy: commonSemanticActionLabels.destroy,
    viewTask: "タスクを見る",
    heartbeat: "ハートビートスナップショット",
    adoptVm: "VM を管理下へ追加",
    releaseVm: "VM を管理から解除",
  },
} as const;
